export const ROOT = '';
export const APP = 'App';
export const OFICINA_VIRTUAL = 'Oficina-virtual';
export const SITIO_PUBLICO = 'Sitio-publico';
export const REPORTES = 'Reportes';
export const DATOS_CLIENTES = 'Datos-clientes';
export const DESCONEXIONES = 'Desconexiones';
export const HOME = 'Login';
export const RED_DE_OFICINAS = 'Red-de-oficinas';
